import { getTenancyByLocalStorage } from "./TenantTypes";
export enum DomainList {
  isec = "thebcrjpxxxx.com",
  bbl = "bcrbullion.com",
  au = "au.thebcr.com",
}

// export const isecDomain = ["jp.thebcr.com", "portal.isec.jp", "thebcrjp.com"];
export const isecDomain = ["thebcrjpxxxx.com"];

export const isIsecDomain = () => {
  const hostname = window.location.hostname;
  if (isecDomain.includes(hostname)) {
    return true;
  }
  return false;
};

export const isBblDomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes(DomainList.bbl)) {
    return true;
  }
  const environment = process.env.VUE_APP_ENV;
  if (environment === "Development") {
    const tenancy = getTenancyByLocalStorage();
    console.log("tenancy in isBblDomain:", tenancy);
    if (tenancy && tenancy === "bbl") {
      return true;
    }
  }
  return false;
};

export const isAuDomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes(DomainList.au)) {
    return true;
  }
  return false;
};
